import React, { Component } from 'react'

import Appointment from '../../components/Appointment/'
import helpers from '../../helpers'

import { Container } from '../../styles/defaults'
import { Box, Header, Content, Title } from './styles'

//NOTE: Date should be passed as MM-DD-YYYY

class Appointments extends Component {
  render() {
    const { appointments } = this.props
    const number = appointments.length

    return (
      <Container mobileFull mt mb>
        <Title>
          <div>Het is vandaag {helpers.today()}</div> - Week {helpers.currentWeek()} 
        </Title>
        <Box>
          <Header>
            {number} {number > 1 || number === 0 ? 'afspraken' : 'afspraak'} gepland
          </Header>
          <Content>
            {appointments.map((appointment, index) => {
              return <Appointment key={index} appointment={appointment} />
            })}
          </Content>
        </Box>
      </Container>
    )
  }
}

export default Appointments



// WEBPACK FOOTER //
// ./src/components/Appointments/index.js